import { render, staticRenderFns } from "./bottomBar.vue?vue&type=template&id=25e0b2ca&scoped=true&"
var script = {}
import style0 from "./bottomBar.vue?vue&type=style&index=0&id=25e0b2ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e0b2ca",
  null
  
)

export default component.exports